import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Spacing } from "@snapchat/snap-design-system";

export const TrendingTagsListContainer = styled.div`
    overflow: hidden;

    width: 100%;

    /* 5 rows of tags + 50px for the header */
    min-height: ${62 * 5 + 50}px;

    border-radius: ${Spacing.XS}px;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 14%);
`;

// TODO: new sds Yellow.V10
export const rowClassname = css`
    cursor: pointer;

    [role="cell"] {
        white-space: normal;
    }

    [role="cell"]:has([role="emphasis"]) {
        background-color: #ffffcf;
    }
`;
